import React from "react";
import axios from "axios";
import SideMenu from "../components/SideMenu";
import { toast } from "react-toastify";

const MyListing = ({ user }) => {
  const [myListings, setMyListings] = React.useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://www.api.webdirectories.info/api/listing/get-by-user/" +
          user._id
      );
      setMyListings(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const formateDate = (date) => {
    const newDate = new Date(date);
    const form = newDate.toLocaleDateString();
    const formate = form.split("/");
    if (formate[0].length === 1) {
      formate[0] = "0" + formate[0];
    }
    if (formate[1].length === 1) {
      formate[1] = "0" + formate[1];
    }
    const formateDate = formate[0] + "-" + formate[1] + "-" + formate[2];
    return `${formateDate}`;
  };
  return (
    <div>
      <div className="container">
        <div className="row flex-nowrap">
          <SideMenu profilePic={user?.profilePic} />
          <div className="col py-3">
            <h2>My Listings</h2>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Listing Type</th>
                  <th>Listing Name</th>
                  <th>Created Date</th>

                  <th>Status </th>
                  <th> Website URL </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {myListings.length > 0 ? (
                  myListings.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.listingType}</td>
                      <td>{item.businessName}</td>
                      <td>{formateDate(item.createdAt)}</td>
                      <td>{item.status}</td>

                      <td>{item.websiteURL}</td>
                      <td className="d-flex">
                        <button variant="primary" className=" btn btn-danger ">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center">
                      <p>No Free Directory Found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyListing;
